<script setup lang="ts">
import { RouterView } from "vue-router"

import ToastContainer from "@/components/ui/ToastContainer.vue"

// Auth interceptor is installed in main.ts before bootstrap() so the cold-start
// getMe call carries the bearer token. Do NOT install it here too — duplicate
// interceptors fire twice per request.
</script>

<template>
  <RouterView />
  <ToastContainer />
</template>
